import PriceOriginComputed from './PriceOriginComputed';

export default class PriceOrigin {
	type: string;

	computed: PriceOriginComputed | null;

	constructor(type: string, computed: PriceOriginComputed | null) {
		this.type = type;
		this.computed = computed;
	}

	get isComputed(): boolean {
		return this.type === 'computed';
	}
}
